__turbopack_context__.v({
  "specs": "styles-module-scss-module__OtoGZa__specs",
});
